<template>
  <div>
    <div class="regAndSign">
      <div class="youXiao">
        <ul class="menuLis">
          <li class="">
            <a href="https://www.myfund.com/" target="_blank">
              <span>首页</span>
            </a>
          </li>
          <li>
            <a href="https://www.myfund.com/woodpecker.html" target="_blank">
              <span>啄木鸟</span>
            </a>
          </li>
          <li>
            <a href="https://www.myfund.com/aboutUs.html?type=map" target="_blank">
              <span>网站地图</span>
            </a>
          </li>
          <li v-if="$commonJs.getCookie('u_custno1') == '3261'">
            <a href="javascript:;">
              <span @click="$router.push({name:'liquidation'})">清算调账</span>
            </a>
          </li>
        </ul>
        <div class="conten">
          <div class="moKuai">
            <img src="https://www.myfund.com/images/top-icon1w.png" alt="" />
            <img src="https://www.myfund.com/images/top-icon1w.png" alt="" />
            <span>{{'欢迎您，'+custname}}</span>
          </div>
          <div class="moKuai moKuaiExit">
            <span style="margin-left: 0px;cursor: pointer;" @click="logout">安全退出</span>
          </div>
          <div class="moKuai">
            <img src="https://www.myfund.com/images/top-icon4w.png" alt="" />
            <span><a href="http://advisor.myfund.com/#/login" target="_blank">顾问登录</a></span>
          </div>
          <div class="moKuai">|</div>
          <div class="moKuai moKuai2">
            <img src="https://www.myfund.com/images/top-icon3w.png" alt="" />
            <img src="https://www.myfund.com/images/top-icon3w.png" alt="" />
            <span><a href="https://www.myfund.com/aboutUs.html" target="_blank">关于我们</a></span>
          </div>
        </div>
      </div>
    </div>
    <div class="navhead2">
      <a href="https://www.myfund.com" target="_blank"><img src="https://www.myfund.com/images/zhx_logo.png" alt=""></a>
      <div class="border" style="border:0">
        <el-input placeholder="请输入基金代码/名称" v-model="NavOneSearchInput" ref="searchRef" @input="input" @focus="enter" class="searchInput input-with-select">
          <el-select v-model="NavOneSearchSelect" slot="prepend" style="width:76px;" @change="change">
            <el-option label="公募" value="公募"></el-option>
            <el-option label="私募" value="私募"></el-option>
          </el-select>
        </el-input>
        <div class="inputCon" v-show="inputConShow" @mouseleave="leave">
          <a v-for="(item,i) in searchArr" :key="i" :href="item.fundCode? 'https://www.myfund.com/mutualfund/'+item.fundCode.substr(0,6)+'.html':'https://www.myfund.com/PrivateFund/'+item.product_code+'.html'" target="_block">
            <span style="width:25%;">{{item.fundCode?item.fundCode:item.product_code}}</span>
            <span style="width:55%;">{{item.fundName?item.fundName:item.product_name}}</span>
            <span style="width:20%;">{{item.fundName?'公募基金':'私募基金'}}</span>
          </a>
        </div>
        <img src="https://www.myfund.com/images/zhx_search.png" alt="" class="sousuoImg" @click="searchImg">
      </div>
      <div v-show="publicShow" class="gmcp">
        <a :href="'https://www.myfund.com/mutualfund/'+item.fundCode+'.html'" target="_block" v-for="(item,i) in publicArr" :key="i">{{item.fundName}}</a>
      </div>
      <div v-show="!publicShow" class="gmcp">
        <a :href="'https://www.myfund.com/PrivateFund/'+item.fundCode+'.html'" target="_block" v-for="(item,i) in privateArr" :key="i">{{item.fundName}}</a>
      </div>

      <img class="callImg" src="https://www.myfund.com/images/zhx_call.png" alt="">
      <ul class="erWeiMa">
        <li>
          <img src="https://www.myfund.com/images/zhx_weixin.png" alt="" class="ig1">
          <div class="d1">微信</div>
          <div class="code">
            <div class="sp1">展恒基金微信公众号</div>
            <img src="https://www.myfund.com/images/zhx_weixinCode.png" alt="" class="ig2">
          </div>
        </li>
        <li>
          <a href="https://weibo.com/myfund888" target="_blank" style="color: #333333;">
            <img src="https://www.myfund.com/images/zhx_weibo.png" alt="" class="ig1">
            <div class="d1">微博</div>
          </a>
          <!--<div class="code">
                <div class="sp1">展恒基金微博</div>
                <img src="https://www.myfund.com/images/zhx_weiboCode.png" alt="" class="ig2">
            </div>-->
        </li>
        <li>
          <img src="https://www.myfund.com/images/zhx_app.png" alt="" class="ig1">
          <div class="d1">APP下载</div>
          <div class="code">
            <div class="sp1 sp2">扫描二维码下载展恒基金</div>
            <img src="https://www.myfund.com/images/zhx_appCode.png" alt="" class="ig2">
            <div class="sp1 sp3">Android&IOS</div>
          </div>
        </li>
      </ul>
      <span class="reXian1">咨询热线</span>
      <span class="reXian2">400-818-8000</span>
      <div id="search_result"></div>
    </div>
    <ul class="navhead3" style="border-bottom: 2px solid #236eac;">
      <li>
        <a href="https://www.myfund.com/mutualFund.html" target="_blank">
          <div class="d1">公募基金</div>
        </a>
        <div class="d2">
          <a href="https://www.myfund.com/youxuan50.html" target="_blank">优选50</a>
          <a href="https://www.myfund.com/woodpecker.html" target="_blank">啄木鸟</a>
          <a href="https://www.myfund.com/accurate_financing.html" target="_blank">精准理财</a>
        </div>
        <br>
        <div class="d2 d3">
          <a href="https://www.myfund.com/pubScreen.html" target="_blank">基金筛选</a>
          <a href="https://www.myfund.com/fundrank.html" target="_blank">基金排名</a>
          <a href="https://www.myfund.com/AutomaticInvestment.html" target="_blank">基金定投</a>
        </div>
      </li>
      <li>
        <a href="https://www.myfund.com/privateChannelNew.html " target="_blank">
          <div class="d1">私募基金</div>
        </a>
        <div class="d2">
          <a href="https://www.myfund.com/ruiSelected.html" target="_blank">睿选100</a>
          <a href="https://www.myfund.com/screenone.html?type=company" target="_blank">私募公司</a>
        </div>
        <br>
        <div class="d2 d3">
          <a href="https://www.myfund.com/screenone.html?type=product" target="_blank">私募筛选</a>
          <a href="https://www.myfund.com/screenone.html?type=manager" target="_blank">私募经理</a>
        </div>
      </li>
      <li style="padding-right: 29px;">
        <a href="https://www.myfund.com/dataservices.html" target="_blank">
          <div class="d1">数据服务</div>
        </a>
        <div class="d2">
          <a href="https://www.myfund.com/WealthManagement.html" target="_blank">财富管理专家</a>
        </div>
        <br>
        <div class="d2 d3">
          <a href="https://www.myfund.com/simu/kingfund.html" target="_blank">金方数据平台</a>
        </div>
      </li>
      <li>
        <a href="https://www.myfund.com/channels/16.html" target="_blank">
          <div class="d1">资讯讲堂</div>
        </a>
        <div class="d2">
          <a href="https://www.myfund.com/channels/17.html" target="_blank">公募研报</a>
          <a href="https://www.myfund.com/channels/18.html" target="_blank">私募研报</a>
        </div>
        <br>
        <div class="d2 d3">
          <a href="https://www.myfund.com/channels/16.html" target="_blank">展恒视角</a>
          <a href="https://www.myfund.com/channels/59.html" target="_blank">基金直播</a>
        </div>
      </li>
      <li>
        <a href="https://trade.myfund.com/kfit/page/frame/frame.htm " target="_blank">
          <div class="d1">个人中心</div>
        </a>
        <div class="d2">
          <a href="https://trade.myfund.com/personal/#/myAssets" target="_blank">我的资产</a>
          <a href="https://trade.myfund.com/personal/#/accountManagement" target="_blank">账户管理</a>
        </div>
        <br>
        <div class="d2 d3">
          <a href="https://trade.myfund.com/personal/#/myChoice" target="_blank">我的自选</a>
          <a href="https://trade.myfund.com/personal/#/myDiagnosis" target="_blank">我的诊断</a>
        </div>
      </li>
    </ul>

  </div>
</template>

<script>
const Base64 = require("js-base64").Base64;
export default {
  name: "lv-header",
  data () {
    return {
      NavOneSearchInput: '',
      NavOneSearchSelect: '公募',
      activeIndex: '1',
      custname: '',
      publicArr: [],
      privateArr: [],
      searchArr: [],
      publicShow: true,
      inputConShow: false,
    }
  },
  mounted () {
    this.getSearch()
    this.publicFund()
    this.privateFund()
    this.custname = this.$route.name == 'indexno' ? this.$commonJs.getCookie('register-phone') : Base64.decode(this.$commonJs.getCookie('u_name1'))
  },
  created () {

  },
  methods: {
    logout () {
      window.sessionStorage.clear()
      this.$commonJs.delCookie('acticePath', '', -1)
      this.$commonJs.delCookie('sessionid', '', -1)
      this.$commonJs.delCookie('u_phone1', '', -1)
      this.$commonJs.delCookie('u_name1', '', -1)
      this.$commonJs.delCookie('u_id', '', -1)
      this.$commonJs.delCookie('Password', '', -1)
      this.$commonJs.delCookie('u_custno1', '', -1)
      this.$commonJs.setDomainCookie('u_name', '', -1)
      this.$commonJs.setDomainCookie('dct_Member', '', -1)
      this.$commonJs.setDomainCookie('u_risk', '', -1)
      this.$commonJs.setDomainCookie('u_custno', '', -1)
      this.$commonJs.setDomainCookie('u_phone', '', -1)
      this.$router.push({ name: 'login' })
    },
    getSearch () {
      this.$http.get('https://www.myfund.com/webinterface/Bamboo.ashx?command=search_index&type=' + this.NavOneSearchSelect + '&info=' + this.NavOneSearchInput + '&flag=all&user=admin').then(res => {
        // console.log(res);
        if (res.status !== 200 && res.data.Result) return
        this.searchArr = res.data.fundlist
      }).catch(err => { })
    },
    searchInput () {

    },
    publicFund () {
      this.$http.get('https://www.myfund.com/webinterface/Bamboo.ashx?command=HotSearch', {}).then(res => {
        if (res.status !== 200 && res.data.Result) return
        this.publicArr = res.data.list
      }).catch(err => { })
    },
    privateFund () {
      this.$http.get('https://www.myfund.com/webinterface/Bamboo.ashx?command=RecommendList', {}).then(res => {
        if (res.status !== 200 && res.data.Result) return
        this.privateArr = res.data.hotSellFundList
      }).catch(err => { })
    },
    change (val) {
      val == '公募' ? this.publicShow = true : this.publicShow = false
    },
    searchImg () {
      window.open('https://www.myfund.com/pubSearchResult.html?key=' + this.NavOneSearchInput, '_blank')
    },
    input (val) {
      val == '' ? this.inputConShow = false : this.inputConShow = true
      this.getSearch()
    },
    enter () {
      this.$refs.searchRef.focus()
      this.inputConShow = true
    },
    leave () {
      this.$refs.searchRef.blur()
      this.inputConShow = false
    }
  }
}
</script>

<style lang="less" scoped>
a {
  color: #fff;
}
.inputCon {
  width: 429px;
  border: 1px solid #ddd;
  background-color: white;
  height: auto;
  position: absolute;
  top: 50px;
  z-index: 999999;
  padding-bottom: 10px;
  padding-left: 20px;
  color: #888;
  font-size: 16px;
  a {
    display: block;
    height: 30px;
    line-height: 30px;
    cursor: pointer;
    color: #999;
    span {
      display: inline-block;
      font-size: 14px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}
</style>
